export default __webpack_public_path__ + "static/media/Assam.57a9ef82.png";